import { Order } from './order';
import { PaymentFrequencyType, PaymentType } from './payment';

export const BILLING_PLAN_MANAGEMENT_OFFER = 'OFFER';

export type SalesPackageSelector = {
  salesPackageId: string;
  paymentStrategyId: number;
};

export type SalesPackageItem = {
  title?: string;
  description?: string;
};

export type PaymentStrategy = {
  id: number;
  title?: string;
  netAmount: number;
  paymentFrequencyType: PaymentFrequencyType;
  paymentFrequency?: string;
  payPalPlanId?: string;
  paymentOptions: PaymentType[];
  savings?: number;
  showcaseNetAmount?: number;
  showcasePaymentFrequency?: string;
};

export type SalesPackage = {
  id: number;
  name: string;
  planId: string;
  description: string;
  items?: SalesPackageItem[];
  paymentStrategies: PaymentStrategy[];
  shortName: string;
  offer?: Order;
  displayRow: number;
  purchaseAction: string;
};
